import {Role} from '@/views/variables/roles'
import store from '@/store'

const admin = [
  {
    path: '/admin',
    component: () => import('@/views/layout/Main'),
    redirect: () =>
      store.state.auth.user
        ? store.state.auth.user.roles[0] === Role.Admin
          ? '/admin/community/list'
          : '/houses/list'
        : '/login',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'community/list',
        name: 'CommunityAdminList',
        title: 'Товарищества',
        component: () => import('@/views/pages/adminPanel/community/List'),
        icon: 'three-towers',
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        },
        display: true
      },
      {
        path: 'community/list/:id',
        name: 'CommunityItem',
        component: () => import('@/views/pages/adminPanel/community/Item'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        }
      },
      {
        path: 'chairman/list',
        name: 'ChairmanAdminList',
        title: 'Председатели',
        component: () => import('@/views/pages/adminPanel/chairman/List'),
        icon: 'person',
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        },
        display: true
      },
      {
        path: 'chairman/list/:id',
        name: 'ChairmanItem',
        component: () => import('@/views/pages/adminPanel/chairman/Item'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        }
      },
      {
        path: 'house/list',
        name: 'HouseAdminList',
        title: 'Дома',
        component: () => import('@/views/pages/adminPanel/house/List'),
        icon: 'two-towers',
        iconRatio: 1,
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        },
        display: true
      },
      {
        path: 'house/list/:id',
        name: 'HomeItem',
        component: () => import('@/views/pages/adminPanel/house/Item'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        }
      },
      {
        path: 'house/list/:id/apartment/:apartmentId',
        name: 'ApartmentItemAdmin',
        component: () => import('@/views/pages/adminPanel/house/apartment/Item'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        }
      },
      {
        path: 'house/list/:id/apartment/:apartmentId/action/:actionId',
        name: 'ApartmentInfoAdmin',
        component: () => import('@/views/pages/adminPanel/house/apartment/Info'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        }
      },
      {
        path: 'applications/list',
        name: 'ApplicationAdminList',
        title: 'Заявки',
        component: () => import('@/views/pages/adminPanel/application/List'),
        icon: 'applications-list',
        iconRatio: 1.26,
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        },
        display: true
      },
      {
        path: 'report/list',
        name: 'ReportAdminList',
        title: 'Финансовые отчеты',
        component: () => import('@/views/pages/adminPanel/report/List'),
        icon: 'report',
        meta: {
          requiresAuth: true,
          authorize: [Role.Admin]
        },
        display: true
      }
    ]
  }
]

export default admin
